import { ecgProjectionAdapter, getECGProjectionSnapshot, } from './ecgProjectionAdapter';
export { createDefaultECGRenderPaths, createECGRenderPathResolver, } from './ECGRenderPathResolver';
export { DefaultECGDataProvider } from './DefaultECGDataProvider';
export const ecgProjection = {
    adapter: ecgProjectionAdapter,
    getSnapshot: getECGProjectionSnapshot,
};
export { default } from './ECGViewport';
